import React from 'react'
import './Madeby.css'

export default function Madeby() {
    return (
        <div className="madeby">
            <div className="wrapper">
                Created by <span>Lin Zhiwei</span>| 
                <i className="fa fa-copyright" aria-hidden="true"></i>
                2021 All rights reserved.
            </div>
        </div>
    )
}
